import { TileSelection } from './types.ts';

export function tileToIndex(row: number, col: number, gridSize: number): number {
  return row * gridSize + col;
}

export function indexToTile(index: number, gridSize: number): { row: number; col: number } {
  return {
    row: Math.floor(index / gridSize),
    col: index % gridSize,
  };
}

export function normalizeTileIndex(selection: TileSelection, gridSize: number): number {
  if (typeof selection === 'number') {
    return selection;
  }
  return tileToIndex(selection.row, selection.col, gridSize);
}

export function normalizeTileIndices(
  selections: TileSelection[],
  gridSize: number
): number[] {
  return selections.map((tile) => normalizeTileIndex(tile, gridSize));
}
